import React, { Fragment } from 'react'
import { Breadcrumbs, UL } from '../../../AbstractElements';
import DataGridView from './DataGridView';
import { Container } from 'reactstrap';

// The tenant/date summary view - datamode-agnostic, same as the live Data Grid.
// Item-level and invoice-level UAT detail live on their own pages (UATItemGrid / UATInvoiceGrid).
const UATDataGrid = () => {
    if (localStorage.getItem("usertype") !== "Backend User") {
        alert('You are not authorized to view this page');
        window.history.back(); // Navigate back to the previous URL
    }

    return (
        <UL attrUL={{ className: 'simple-list nav-menus flex-row' }}>
            <Fragment>
                <Breadcrumbs parent="Data Grid - UAT" title="Data Grid - UAT" mainTitle="Data Grid - UAT" />
                <Container fluid={true}>
                    <DataGridView source="uat" />
                </Container>
            </Fragment>
        </UL>
    )
}

export default UATDataGrid
